import { createRouter, createWebHashHistory } from 'vue-router'
import store from '../store'

import MainView from '@/views/MainView.vue';
// import LoginView from '@/views/LoginView.vue';
import DesignsView from '@/views/ProjectsView.vue';
import LandingView from '@/views/LandingView.vue';
import PreRegisterView from '@/views/PreRegisterView.vue';

const routes = [
    {
        path: '/editor',
        name: 'editor',
        component: MainView,
        // meta: { requiresAuth: true }
    },
    {
        path: '/projects',
        name: 'projects',
        component: DesignsView,
        // meta: { requiresAuth: true }
    },
    // {
    //     path: '/login',
    //     name: 'login',
    //     component: LoginView
    // },
    {
        path: '/pre-register',
        name: 'pre-register',
        component: PreRegisterView
    },
    {
        path: '/',
        name: 'main',
        component: LandingView
    },
]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    const isAuthenticated = !!store.state.login;

    if (to.meta.requiresAuth && !isAuthenticated) {
        next({ name: 'pre-register' });
    } else if (to.name === 'pre-register' && isAuthenticated) {
        next({ name: 'projects' });
    } else {
        next();
    }
})

export default router
